import React,{useState,useEffect} from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Label, Input} from "reactstrap";
import API from "../../utils/API";
import {useHistory} from "react-router-dom";
import {toastr} from "react-redux-toastr";

const CopyFunctionality = ({publisher,copy,setCopy}) => {
    const [types,setTypes] = useState(null)
    const [settings, setSettings] = useState([])
    const [name, setName] = useState(null)
    let history = useHistory();

    const handleCheckboxChange = (e) => {
        let tempSettings = [...settings]
        if (!tempSettings.includes(e.target.value)) {
            tempSettings.push(e.target.value)
        }else {
            tempSettings = tempSettings.filter(item => item !== e.target.value)
        }

        setSettings(tempSettings)
    }

    const runCopy = () => {
        API.post('/admin/copying/publisher/'+publisher.id,{types:settings,params:{name:name}}).then((response) => {
            toastr.success('Success', 'Publisher copied successfully!')
            setCopy(false)
            history.push("/publisher/item/"+response.data.data)
        }).catch((error) => {
            console.error('Publisher copy error:', error)
            toastr.error('Error', 'Failed to copy Publisher')
        });
    }

    useEffect(()=>{
        if (copy && publisher) {
            API.get('/admin/copying/publisher').then((response) => {
                setTypes(response.data.data)
                setSettings(response.data.data)
            });
        }
    },[copy])

    return (<>
        {copy &&
            <Modal
                isOpen={copy}
                toggle={() => setCopy(false)}
                className="modal-dialog-centered"
                size="lg"
            >
                <ModalHeader toggle={() => setCopy(false)}>
                    Copy Publisher: {publisher.name}
                </ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label for="name">New Publisher Name</Label>
                        <Input
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Enter new publisher name"
                            value={name || ''}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </FormGroup>
                    <div>
                        <Label>Select what to copy:</Label>
                        {types && types.map((type, index) => (
                            <FormGroup check key={index}>
                                <Label check>
                                    <Input
                                        type="checkbox"
                                        value={type}
                                        checked={settings.includes(type)}
                                        onChange={handleCheckboxChange}
                                    />
                                    {type}
                                </Label>
                            </FormGroup>
                        ))}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setCopy(false)}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={runCopy}>
                        Copy Publisher
                    </Button>
                </ModalFooter>
            </Modal>
        }
    </>)
}

export default CopyFunctionality;
